/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface AssetAccountRequest
 */
export interface AssetAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetAccountRequest
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountRequest
     */
    bankName: string | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof AssetAccountRequest
     */
    address: AddressDto | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountRequest
     */
    iban: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAccountRequest
     */
    incomings: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAccountRequest
     */
    isOverdrawn: boolean | null;
}

/**
 * Check if a given object implements the AssetAccountRequest interface.
 */
export function instanceOfAssetAccountRequest(value: object): value is AssetAccountRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('bankName' in value) || value['bankName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('incomings' in value) || value['incomings'] === undefined) return false;
    if (!('isOverdrawn' in value) || value['isOverdrawn'] === undefined) return false;
    return true;
}

export function AssetAccountRequestFromJSON(json: any): AssetAccountRequest {
    return AssetAccountRequestFromJSONTyped(json, false);
}

export function AssetAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'bankName': json['bankName'],
        'address': AddressDtoFromJSON(json['address']),
        'iban': json['iban'],
        'incomings': json['incomings'],
        'isOverdrawn': json['isOverdrawn'],
    };
}

export function AssetAccountRequestToJSON(json: any): AssetAccountRequest {
    return AssetAccountRequestToJSONTyped(json, false);
}

export function AssetAccountRequestToJSONTyped(value?: AssetAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'bankName': value['bankName'],
        'address': AddressDtoToJSON(value['address']),
        'iban': value['iban'],
        'incomings': value['incomings'],
        'isOverdrawn': value['isOverdrawn'],
    };
}

